import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { Subject } from "rxjs/Subject";
import { Subscription } from "rxjs/Subscription";
import { AccountService } from "../../shared/account/account.service";
import { BillTypeService } from "../../shared/bill/bill-type.service";
import { PaymentService } from "../../shared/payment/payment.service";
import { AuthService } from "../../shared/services/auth.service";
import { BackendService } from "../../shared/services/backend.service";
import { LoaderService } from "../../shared/services/loader.service";
import { Constants } from "../../helper/constants";

@Component({
  selector: "app-payment-verification",
  templateUrl: "./payment-verification.component.html",
  styleUrls: ["./payment-verification.component.scss"]
})
export class PaymentVerificationComponent implements OnInit, OnDestroy {
  payments;
  statusList = [];
  payment;
  billTypes;
  billType = { name: "" };
  searchKeyword;
  loading = false;
  modalReference: NgbModalRef;
  status;
  comment;
  oldStatus;
  oldComment;
  page = 1;
  userId: string;
  authState;
  routeSubscription: Subscription;
  activeRouteIndex;
  communityId: string;
  subscription: Subscription;
  successMessage: string;
  errorMessage: string;
  _alert = new Subject<string>();
  order = "date";
  reverse = true;
  partPaymentStatus;

  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private billTypeService: BillTypeService,
    private loaderService: LoaderService,
    private paymentService: PaymentService
  ) {
    this.billType.name = "";
    this.searchKeyword = "";
    this.payment = "";
    this.status = "";
    this.comment = "";
    this.oldStatus = "";
    this.oldComment = "";
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
    this.partPaymentStatus = Constants.PART_PAYMENT_STATUS;
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.routeSubscription = this.accountService
      .getProfile(this.userId)
      .subscribe((profile: any) => {
        this.route.params.subscribe(params => {
          this.activeRouteIndex = parseInt(params.index, 10);
          const activeRole: any = profile.roles[this.activeRouteIndex];
          this.communityId = activeRole.communityId;
          this.getPayments(this.communityId);
          this.billTypes = this.billTypeService.getCommunityBillTypes(
            this.communityId
          );
        });
        this.loaderService.stopLoader();
      });
  }

  viewPayment(payment, modal): void {
    this.payment = payment;
    this.status = this.payment.status;
    this.comment = this.payment.comment;
    this.oldStatus = this.payment.status;
    this.oldComment = this.payment.comment;

    this.initializeVerificationStatuses(this.payment);

    this.open(modal);
  }

  initializeVerificationStatuses(payment): void {
    this.statusList = Constants.VERIFICATION_STATUS;
  }

  open(modal): void {
    this.modalReference = this.modalService.open(modal);
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  async verify(): Promise<void> {
    const result = await this.paymentService.verifyPayment(this.communityId,
      this.payment, this.status, this.comment, this.userId
    );
    if (result.status) {
      this.showAlert(true, result.message);
      this.closeModal();
    } else {
      this.closeModal();
      this.showAlert(false, result.message);
    }
  }

  showAlert(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.successMessage = message)
          : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.successMessage = undefined)
            : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  private getPayments(communityId): any {
    this.payments = this.paymentService.getPayments(communityId, "pending");
  }

  setSortOrder(value: string): void {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  ngOnDestroy(): void {
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/payment-verification/payment-verification.component.ts